import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-steps-confirmation-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './steps-confirmation-modal.component.html',
  styleUrl: './steps-confirmation-modal.component.scss'
})
export class StepsConfirmationModalComponent {
  activeModal = inject(NgbActiveModal);
  private modalService = inject(NgbModal);

  @Input()
  configs: any = {};
  isActive:boolean = false;

  onClick(){
    this.activeModal.close();
  }
}
